export const themes = {
  thumbnail: {
    thPriceTheme: 'inline',
  },
};
